// extracted by mini-css-extract-plugin
export default {"loadingAnimation":"LoadingAnimation_loadingAnimation__H-3yJ","fixed":"LoadingAnimation_fixed__CUXW8"};